import React from "react";

const Footer = () => {
  return (
    <footer className="MainFooter mt-auto">
      <p className="text-center , pt-4">
        Made with ❤️ by{" "}
        <a href="https://hellomohitsangwan.github.io/ms/">Mohit</a>{" "}
      </p>{" "}
      <p className="text-center pb-4">Copyright &copy; 2021</p>
    </footer>
  );
};

export default Footer;
